import React from "react"
import axios from "axios"
import { connect } from "react-redux"
import { withTranslation } from "react-i18next"
import {
  Button,
  Card,
  CardBody,
  CustomInput,
  Form,
  FormGroup,
  Input,
  Label,
  Table,
} from "reactstrap"
import { MultiSelect } from "react-multi-select-component"

import { Loading, PageContainer } from "../../components"
import { fetchResources, fail } from "../../actions"

// Admin management of resellers: create, allocate customers, toggle active
class Resellers extends React.Component {
  state = {
    newName: "",
    creating: false,
    editingId: null,
    selectedCustomers: [],
    saving: false,
  }

  componentDidMount = () => {
    this.props.fetchResources({ resource: "resellers", force: true })
    this.props.fetchResources({ resource: "customers" })
  }

  create = async (e) => {
    e.preventDefault()
    this.setState({ creating: true })
    try {
      await axios.post("/resellers", { name: this.state.newName })
      this.setState({ creating: false, newName: "" })
      this.props.fetchResources({ resource: "resellers", force: true })
    } catch (error) {
      this.props.fail(null, error).then(() => this.setState({ creating: false }))
    }
  }

  startEdit = (reseller) => {
    const allocated = (reseller.customerIds || []).map((id) =>
      id.toLowerCase()
    )
    this.setState({
      editingId: reseller.id,
      selectedCustomers: this.props.customers.customers
        .filter((c) => allocated.includes(c.id.toLowerCase()))
        .map((c) => ({ value: c.id, label: c.companyName })),
    })
  }

  saveEdit = async () => {
    this.setState({ saving: true })
    try {
      await axios.put(`/resellers/${this.state.editingId}`, {
        customerIds: this.state.selectedCustomers.map((c) => c.value),
      })
      this.setState({ saving: false, editingId: null })
      this.props.fetchResources({ resource: "resellers", force: true })
    } catch (error) {
      this.props.fail(null, error).then(() => this.setState({ saving: false }))
    }
  }

  toggleActive = async (reseller) => {
    try {
      await axios.put(`/resellers/${reseller.id}`, {
        active: !reseller.active,
      })
      this.props.fetchResources({ resource: "resellers", force: true })
    } catch (error) {
      this.props.fail(null, error)
    }
  }

  render() {
    const { t } = this.props
    const resellers = this.props.resellers.resellers || []
    return (
      <PageContainer
        title={t("_resellers")}
        loading={this.props.resellers.fetching}
      >
        <Card className="mb-3">
          <CardBody>
            <Form onSubmit={this.create} className="d-flex">
              <Input
                className="mr-2"
                style={{ maxWidth: 300 }}
                value={this.state.newName}
                placeholder={t("_resellerName")}
                onChange={(e) => this.setState({ newName: e.target.value })}
              />
              {this.state.creating ? (
                <Loading small />
              ) : (
                <Button
                  type="submit"
                  color="primary"
                  disabled={!this.state.newName.trim()}
                >
                  {t("_createReseller")}
                </Button>
              )}
            </Form>
          </CardBody>
        </Card>
        <Table>
          <thead>
            <tr>
              <th>{t("_name")}</th>
              <th>{t("_allocatedCustomers")}</th>
              <th>{t("_users")}</th>
              <th>{t("_active")}</th>
              <th />
            </tr>
          </thead>
          <tbody>
            {resellers.map((r) => (
              <tr key={r.id}>
                <td style={{ verticalAlign: "middle" }}>{r.name}</td>
                <td style={{ verticalAlign: "middle", minWidth: 300 }}>
                  {this.state.editingId === r.id ? (
                    <>
                      <MultiSelect
                        options={this.props.customers.customers.map((c) => ({
                          value: c.id,
                          label: c.companyName,
                        }))}
                        value={this.state.selectedCustomers}
                        onChange={(selectedCustomers) =>
                          this.setState({ selectedCustomers })
                        }
                        hasSelectAll={false}
                        isLoading={this.props.customers.fetching}
                        valueRenderer={(selected) =>
                          `${selected.length} ${t("_customers")}`
                        }
                      />
                      <div className="mt-2">
                        {this.state.saving ? (
                          <Loading small />
                        ) : (
                          <>
                            <Button
                              size="sm"
                              color="primary"
                              className="mr-2"
                              onClick={this.saveEdit}
                            >
                              {t("_update")}
                            </Button>
                            <Button
                              size="sm"
                              color="secondary"
                              onClick={() => this.setState({ editingId: null })}
                            >
                              {t("_cancel")}
                            </Button>
                          </>
                        )}
                      </div>
                    </>
                  ) : (
                    `${(r.customerIds || []).length} ${t("_customers")}`
                  )}
                </td>
                <td style={{ verticalAlign: "middle" }}>{r.userCount}</td>
                <td style={{ verticalAlign: "middle" }}>
                  <CustomInput
                    type="switch"
                    id={`active-${r.id}`}
                    checked={r.active}
                    onChange={() => this.toggleActive(r)}
                  />
                </td>
                <td style={{ verticalAlign: "middle" }}>
                  {this.state.editingId !== r.id && (
                    <Button size="sm" onClick={() => this.startEdit(r)}>
                      {t("_allocateCustomers")}
                    </Button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </PageContainer>
    )
  }
}

export default connect(
  (s) => ({ resellers: s.resellers, customers: s.customers }),
  { fetchResources, fail }
)(withTranslation()(Resellers))
